import React from 'react';

import { FeatureRenderer } from '@src/hoc/FeatureRenderer';
import { INSIGHTS_EXCLUDED_PLANS } from '@src/plans-permissions';

// Every Insights screen goes through here, so the plans the API does not score are left out in one place.
export const InsightsFeatureRenderer = (props) => <FeatureRenderer {...props} constraints={INSIGHTS_EXCLUDED_PLANS} />;



// WEBPACK FOOTER //
// ./src/hoc/InsightsFeatureRenderer.jsx